import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const ErrorRectangleSmooth = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_91959_431707)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.68597 4.68743C3.3731 6.00031 3.27575 7.3083 3.08105 9.92429C3.03058 10.6024 3 11.3019 3 12.0015C3 12.701 3.03058 13.4005 3.08105 14.0786C3.27575 16.6946 3.3731 18.0026 4.68597 19.3155C5.99884 20.6284 7.30684 20.7257 9.92282 20.9204C10.601 20.9709 11.3005 21.0015 12 21.0015C12.6995 21.0015 13.399 20.9709 14.0772 20.9204C16.6932 20.7257 18.0012 20.6284 19.314 19.3155C20.6269 18.0026 20.7243 16.6946 20.9189 14.0786C20.9694 13.4005 21 12.701 21 12.0015C21 11.3019 20.9694 10.6024 20.9189 9.92429C20.7243 7.3083 20.6269 6.00031 19.314 4.68743C18.0012 3.37456 16.6932 3.27721 14.0772 3.08252C13.399 3.03205 12.6995 3.00146 12 3.00146C11.3005 3.00146 10.601 3.03205 9.92282 3.08252C7.30684 3.27721 5.99884 3.37456 4.68597 4.68743ZM15.2071 8.79241C15.5976 9.18293 15.5976 9.81609 15.2071 10.2066L13.414 11.9997L15.2071 13.7927C15.5976 14.1833 15.5976 14.8164 15.2071 15.207C14.8166 15.5975 14.1834 15.5975 13.7929 15.207L11.9998 13.4139L10.2071 15.2066C9.81658 15.5971 9.18342 15.5971 8.79289 15.2066C8.40237 14.8161 8.40237 14.1829 8.79289 13.7924L10.5856 11.9997L8.7929 10.207C8.40237 9.81643 8.40237 9.18327 8.7929 8.79274C9.18342 8.40222 9.81658 8.40222 10.2071 8.79274L11.9998 10.5855L13.7929 8.79241C14.1834 8.40188 14.8166 8.40188 15.2071 8.79241Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_91959_431707">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ErrorRectangleSmooth;
